import AgaveState from './agave'
import ParticipantState from './participant'
import PresenterState from './presenter'
import EmbedState from './embed'
import AuthState from './auth'

export function getState (options) {
  switch (options.role) {
    case 'participant':
      return new ParticipantState(options)
    case 'agave':
      return new AgaveState(options)
    case 'embed':
      return new EmbedState(options)
    case 'auth':
      return new AuthState(options)
    default:
      return new PresenterState(options)
  }
}
